import { render, staticRenderFns } from "./PreviewModeCloseButton.vue?vue&type=template&id=0fd79cbe&"
import script from "./PreviewModeCloseButton.vue?vue&type=script&lang=ts&"
export * from "./PreviewModeCloseButton.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewModeCloseButton.vue?vue&type=style&index=0&id=0fd79cbe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports